module.exports = __webpack_public_path__ + "static/media/IMG-5.d3c6cf5e.jpg";